export default {"src":"/_next/static/media/sauna.7bbb4175.svg","height":100,"width":100};